module.exports = __webpack_public_path__ + "media/eat.84eb264a.wav";